'use client'

import { Query, GetOrder } from '@wolfdanepug/common-react'
import OrderDetail from '../../../components/order/OrderDetail'
import { useParams } from 'react-router'
import { useContext, useEffect } from 'react'
import { PageContext } from '../../../context/page'

export default function OrderDetailPage() {
	const { id } = useParams()
	const orderId = id?.split('-').pop()?.toUpperCase() || id
	const { setPage } = useContext(PageContext)

	useEffect(() => {
		setPage({
			title: 'Order Details',
			description: orderId,
			canGoBack: '/settings/orders'
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [orderId])

	return (
		<>
			<Query
				doc={GetOrder}
				component={OrderDetail}
				variables={{ id }}
				getData={(data: any) => ({ order: data })}
			/>
		</>
	)
}
